import { Button, ButtonVariants, Icon } from '@platform/components';
import { ReactNode } from 'react';

type CommunityCardProps = {
  date?: Date;
  title: string;
  subheader?: ReactNode;
  description: string;
  link?: string;
  cta?: string;
  ctaVariant?: ButtonVariants;
};

export const CommunityCard = (props: CommunityCardProps) => {
  const {
    date,
    title,
    subheader,
    description,
    cta,
    link,
    ctaVariant = 'secondary-color',
  } = { ...props };
  return (
    <div className='flex flex-row border-b border-gray-100 first:pt-0 last:border-none last:pb-0 w-full py-4 gap-4 relative'>
      <div
        className='block md:hidden absolute w-full h-full z-10 cursor-pointer'
        onClick={() => {
          //Invisible click capturing overlay to make the whole card clickable area on phone screens
          if (link) {
            window.open(link);
          }
        }}
      />
      {date && (
        <div className='bg-gray-100 flex flex-col gap-1 rounded-xl py-1 px-2 w-12 h-14 justify-center text-center'>
          <div className='font-bold text-md text-gray-700'>{date.getDate()}</div>
          <div className='text-xs text-gray-500'>
            {date.toLocaleDateString('default', { month: 'short' }).toUpperCase()}
          </div>
        </div>
      )}
      <div className='flex flex-wrap md:flex-nowrap flex-col gap-1 justify-center w-full'>
        <a
          className={`text-lg text-gray-700 ${
            link ? 'md:hover:text-brand-500 md:hover:underline cursor-pointer' : ''
          }`}
          href={link}
          target='_blank'
        >
          {title}
        </a>
        {subheader && <div className='text-gray-500 text-sm'>{subheader}</div>}
        <div className='flex flex-wrap md:flex-nowrap flex-col md:flex-row gap-8'>
          <div className='min-w-[calc(100%-160px)] text-gray-500 text-md items-center overflow-wrap line-clamp-3'>
            {description}
          </div>
          {link && cta && (
            <div className='min-w-[125px] shrink-0'>
              <Button href={link} target='_blank' variant={ctaVariant} size='md'>
                {cta} <Icon type='arrow-up-right' size='20' />
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
